module.exports = __webpack_public_path__ + "img/input-arrow.72bebd16.svg";